import { Component, OnInit } from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientServiceService} from '../../client/client-service/client-service.service';
import {ToastrService} from 'ngx-toastr';
import {CampaignService} from '../service/campaign.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-campaign-form',
  templateUrl: './campaign-form.component.html',
  styleUrls: ['./campaign-form.component.css']
})
export class CampaignFormComponent implements OnInit {
  form: FormGroup;
  campaignDetailForm: FormGroup;
  patientId: any;
  loading: boolean;
  submitted: boolean;
  isSelected: true;
  monitoringDurationList: any [];
  monitoringUnitsList: any [];
  clientContacts: any = [];
  deviceConfiguration: any [];
  leadConfiguration: any ;
  monitoringFrequencyList: any [];
  patient: any;

  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private campaignService: CampaignService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {
    this.route.fragment.subscribe(fragment => { this.patientId = fragment; });
    this.getPatientDetails(this.patientId);

    console.log(this.patientId);
    this.campaignDetailForm = this._formBuilder.group({
      id: [''],
      monitoringIds: [null],
      clientId: localStorage.getItem('clientId'),
      patientId: this.patientId,
      reportFrequency: ['', Validators.required],
      monitoringDuration: ['', Validators.required],
      deviceConfiguration: new FormArray([], minSelectedCheckboxes(1)),
      monitoringUnit: ['', Validators.required],
      comments: [''],
      leadConfiguration: ['', Validators.required],
      clientContacts: this._formBuilder.array([this.createClientContacts()]),
    });
     this.deviceConfiguration = this.getAllMonitoringDeviceConfig();
     this.addCheckboxes();
  }

  createClientContacts(): FormGroup {
    return this._formBuilder.group({
      firstName: ['', Validators.required],
      userType: ['PHYSICIAN', Validators.required],
      email: ['', Validators.required]
    });
  }


  addItem() {
    this.clientContacts = this.campaignDetailForm.get('clientContacts') as FormArray;
    this.clientContacts.push(this.createClientContacts());
  }

  private addCheckboxes() {
    this.deviceConfiguration.map((o, i) => {
      const control = new FormControl(i === 0); // if first item set to true, else false
        (this.campaignDetailForm.controls.deviceConfiguration as FormArray).push(control);
    });
  }

  ngOnInit() {
    this.getAllMonitoringFrequency();
    // this.getAllMonitoringDuration();
    this.getAllMonitoringUnits();
    // this.getAllMonitoringDeviceConfig();
  }

  updateDropDown() {
      console.log(this.campaignDetailForm.value.monitoringUnit);
      if (this.campaignDetailForm.value.monitoringUnit === 'DAYS') {
        this.monitoringDurationList = [1, 2, 3, 4, 5, 6, 7, 30];
      }
      if (this.campaignDetailForm.value.monitoringUnit === 'HOURS') {
        this.monitoringDurationList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      }
      if (this.campaignDetailForm.value.monitoringUnit === 'MINUTES') {
        // tslint:disable-next-line:max-line-length
        this.monitoringDurationList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49.50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
      }
    }

  public getAllMonitoringDuration() {
    this.monitoringDurationList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49.50, 51, 52, 53, 54, 55, 56, 57, 58, 59];
  }
  public getAllMonitoringUnits() {
    this.monitoringUnitsList = [{
      id: 'DAYS',
      name: 'DAYS'
    },
      {
        id: 'HOURS',
        name: 'HOURS'
      },
      {
        id: 'MINUTES',
        name: 'MINUTES'
      }];
  }
  public getAllMonitoringFrequency() {
    this.monitoringFrequencyList = [{
      id : 'HOURLY',
      name: 'HOURLY'
      },
      {
        id : 'DAILY',
        name: 'DAILY'
      },
      {
        id : 'WEEKLY',
        name: 'WEEKLY'
      }];
  }

  public getAllMonitoringDeviceConfig() {
    return  [{
      id : 'ECG_LEAD_VI',
      name: 'ECG_LEAD_VI'
      },
      {
        id : 'ECG_LEAD_XII',
        name: 'ECG_LEAD_XII'
      },
      {
        id : 'BODY_POSTURE_ACTIVITY',
        name: 'BODY_POSTURE_ACTIVITY'
      },
      {
        id : 'SKIN_TEMPERATURE',
        name: 'SKIN_TEMPERATURE'
      },
      {
        id : 'RESPIRATION',
        name: 'RESPIRATION'
      },
      {
        id : 'FALLS',
        name: 'FALLS'
      },
      {
        id : 'BLOOD_PRESSURE',
        name: 'BLOOD_PRESSURE'
      },
      {
        id : 'SPO2_OXIGEN',
        name: 'SPO2_OXIGEN'
      },
      {
        id : 'SPO2_PULSE',
        name: 'SPO2_PULSE'
      },
      {
        id : 'BLOOD_GLUCOSE',
        name: 'BLOOD_GLUCOSE'
      }];
  }
  public saveCampaign(campaignDetailForm: any) {
    this.campaignDetailForm.value.deviceConfiguration[0] = this.campaignDetailForm.value.leadConfiguration;
    const selectedDeviceConfig = this.campaignDetailForm.value.deviceConfiguration
        .map((v, i) => v ? this.campaignDetailForm.value.deviceConfiguration[i] : null)
        .filter(v => v !== null);
    this.campaignDetailForm.value.deviceConfiguration = selectedDeviceConfig;
    this.loading = true;
    this.submitted = true;
    console.log(JSON.stringify(this.campaignDetailForm.value));
    this.campaignService.addUpdateCampaign(campaignDetailForm.value)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Campaign created successfully');
            this.router.navigate(['/elasticcare/campaign']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });
  }

  getPatientDetails(patientId: any) {
    this.campaignService.getPatientDetails(patientId)
        .pipe(first())
        .subscribe(data => {
          console.log('patient' + data.json())
          this.patient = data.json();
        }, (error) => {
          this.toastr.error('', 'Please try again');
        });
  }
}




function minSelectedCheckboxes(min = 1) {
  const validator: ValidatorFn = (formArray: FormArray) => {
    const totalSelected = formArray.controls
    // get a list of checkbox values (boolean)
        .map(control => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => next ? prev + next : prev, 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= min ? null : { required: true };
  };

  return validator;
}
